import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import toast from "react-hot-toast";
import http from "../services/httpService";
import { getDate, searchFilter, handleSort } from "../utils/varialbles";
import SearchBar from "material-ui-search-bar";

const columns = [
  { id: "role", label: "Role", minWidth: 150, maxWidth: 300 },
  { id: "permission", label: "Permission", minWidth: 150, maxWidth: 500 },
  { id: "detailsButton", label: "", minWidth: 150 },
];

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

function RoleList({ changeAciveTab, getState }) {

  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");

  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const [open, setOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const EditUser = (object) => {
    changeAciveTab("Users");
  };
  const DeleteRole = (object) => {
    setCurrentUser(object);
    setOpen(true);
  };
  const submitDelete = () => {
    http
      .get("/permission_manager")
      .then((res) => {
        if (
          res.data &&
          res.data.Roles &&
          Array.isArray(res.data.Roles) &&
          res.data.Roles.length > 0
        ) {
          let role_id = res.data.Roles.filter((obj) => {
            return obj.role === currentUser.role;
          });
          if (role_id && role_id.length > 0 && role_id[0]["id"]) {
            http
              .get("/delete_permissions/" + role_id[0]["id"])
              .then((response) => {
                if (response.data.statusCode === 0) {
                  toast.success(response.data.data);
                  setOpen(false);
                  handleCancel();
                } else {
                  toast.error(response.data.data);
                }
              })
              .catch((err) => { });
          } else {
            toast.error("No corresponding role found..!");
          }
        } else {
          toast.error("No corresponding role found..!");
        }
      })
      .catch((err) => { });
  };
  const handleCancel = () => {
    toast.loading("Please wait...");

    http
      .get("/permission_manager_list")
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.data &&
          Array.isArray(response.data.data) &&
          response.data.statusCode === 0
        ) {
          response.data.data = response.data.data.map((obj, inx) => {
            return Object.keys(obj).map((key, index) => {
              return {
                role: key,
                permission: Array.isArray(obj[key]) ? obj[key].join() : "",
              };
            })[0];
          });
          setOriginalRows(response.data.data);
          setRows(response.data.data);
          toast.dismiss();
        }
      })
      .catch((error) => { console.log('error') });

  };
  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter")
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem('selectedinvestorfiltersdata')

    getState({});
    handleCancel();
  }, []);
  return (
    <>
      <Paper className={classes.root}>
        <SearchBar
          value={searched}
          onChange={(searchVal) => requestSearch(searchVal)}
          onCancelSearch={() => cancelSearch()}
          className={"mt30"}
        />
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    className='prospect_table'

                    style={{
                      minWidth: column.minWidth,
                      maxWidth: column.maxWidth,
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                rows.length !== 0 ? (
                  <>
                    {rows
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index + "a"}
                            className='prospecttable'

                          >
                            {columns.map((column, index) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  key={index + column.id}
                                  align={column.align}
                                  style={{
                                    minWidth: column.minWidth,
                                    maxWidth: column.maxWidth,
                                  }}
                                >
                                  {column.format && typeof value === "number" ? (
                                    column.format(value)
                                  ) : column.id === "detailsButton" ? (
                                    <div>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ borderRadius: 10 }}
                                        onClick={() => EditUser(row)}
                                      >
                                        Edit
                                      </Button>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ borderRadius: 10, marginLeft: 10 }}
                                        onClick={() => DeleteRole(row)}
                                      >
                                        Delete
                                      </Button>
                                    </div>
                                  ) : column.format === "Date" ? (
                                    getDate(value)
                                  ) : column.operation &&
                                    column.operation === "concate" ? (
                                    value + column.operand + row[column.with]
                                  ) : column.format &&
                                    column.format === "boolean" &&
                                    value ? (
                                    "Active"
                                  ) : column.format &&
                                    column.format === "boolean" &&
                                    !value ? (
                                    "Inactive"
                                  ) : (
                                    value
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </>
                ) : (
                  <TableCell colspan="7" style={{ "text-align": "center", margin: "10px 0px" }} >
                    Data Not Available</TableCell>
                )
              }

            </TableBody>
          </Table>
        </TableContainer>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            Delete Role
          </DialogTitle>
          <DialogContent>
            Are you sure to Delete Role {currentUser.role}?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined">
              No
            </Button>
            <Button
              autoFocus
              onClick={(e) => submitDelete(e)}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </>
  );
}
export default RoleList;
